var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dbf0062f4ca3636a5c8b7142bddfe6d35b2a25b7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"dbf0062f4ca3636a5c8b7142bddfe6d35b2a25b7"};
      